import type { StepType } from '@/app/components/Steps/types';
import type { TimeOfDayType } from '@/types/airRequestApiTypes';
import { TimeOfDay } from '@/types/airRequestApiTypes';

export const AIR_REQUEST_ID_QUERY_KEY = 'air_request_id';
export const AIR_REQUEST_CACHE_KEY = 'air-request-details-cache';
export const AIR_REQUEST_PASSENGERS_CACHE_KEY = 'air_request_passengers';
export const ADD_AIR_REQUEST_PASSENGERS_MUTATION_KEY = ['add-air-request-passengers'] as const;
export const AIR_REQUEST_TRAVELERS_CACHE_KEY = 'client-travelers';
export const RELATIONSHIP_TYPES_CACHE_KEY = 'relationship-types';
export const RELATED_AGENTS_QUERY_KEY = 'related-agents';
export const SEARCH_QUERY_KEY = 'search';
export const PASSENGER_FORM_ID = 'passenger-form';
export const MULTI_TRIP_TYPE_PASSENGER_FORM_ID = 'multi-trip-type-passenger-form';
export const AIRPORT_LIST_CACHE_KEY = 'airport-list';
export const MAX_PASSPORT_FILES_COUNT = 2;
export const PASSENGER_DOCUMENT_PENDING_TIMEOUT_MS = 8_000;
export const MIN_MULTI_CITY_FLIGHTS_COUNT = 2;

export const AIR_REQUEST_TABS = {
  DATE: 'date',
  FLEXIBLE: 'flexible',
} as const;

export type AirRequestTabsLabels = (typeof AIR_REQUEST_TABS)[keyof typeof AIR_REQUEST_TABS];

export const AIR_REQUEST_TRIP_TYPES = {
  ONE_WAY: 1,
  ROUND_TRIP: 2,
  MULTI_CITY: 3,
} as const;

export type AirRequestTripType = (typeof AIR_REQUEST_TRIP_TYPES)[keyof typeof AIR_REQUEST_TRIP_TYPES];
export type BaseListOptionType = {
  name: string;
  id: number;
};

export const TIME_OPTIONS_MAP: Record<TimeOfDayType, string> = {
  [TimeOfDay.MORNING]: 'Morning',
  [TimeOfDay.AFTERNOON]: 'Afternoon',
  [TimeOfDay.EVENING]: 'Evening',
  [TimeOfDay.NIGHT]: 'Night',
};

export const AIR_REQUEST_PRICING_QUOTES = {
  REFUNDABLE_AND_NON_REFUNDABLE: 1,
  REFUNDABLE: 2,
  NON_REFUNDABLE: 3,
} as const;

export const AIR_REQUEST_TRAVEL_PREFERENCES = {
  PRICE_SENSITIVE: 1,
  DIRECT_FLIGHTS_ONLY: 2,
  TRAVELING_WITH_INFANT: 3,
  NO_RED_EYE_FLIGHTS: 4,
  SEATS_TOGETHER: 5,
  EXTRA_LEGGROOM: 6,
  LIE_FLAT_SEATING: 7,
  FLEXIBLE_DATES: 8,
  SEATING_PREFERENCE: 9,
} as const;
export const SEATING_PREFERENCE_VALUE = {
  WINDOW: 'WINDOW',
  AISLE: 'AISLE',
} as const;
export type AirRequestSeatingPreference = (typeof SEATING_PREFERENCE_VALUE)[keyof typeof SEATING_PREFERENCE_VALUE];

export type AirRequestTravelPreference =
  (typeof AIR_REQUEST_TRAVEL_PREFERENCES)[keyof typeof AIR_REQUEST_TRAVEL_PREFERENCES];

export type AirRequestPricingQuote = (typeof AIR_REQUEST_PRICING_QUOTES)[keyof typeof AIR_REQUEST_PRICING_QUOTES];

export const AIR_REQUEST_NIGHTS_MIN = 1;
export const AIR_REQUEST_NIGHTS_MAX = 31;

export const AIR_REQUEST_SELECTOR_CACHE_TIME_MS = 10 * 60 * 1000;

export const AIR_REQUEST_TEST_AGENT_WARNING = (email: string) =>
  `It looks like you are testing Air Request. Agent and marketing emails for this request will be sent to ${email}.`;

export const AIR_FORM_STEPS: StepType[] = [
  { label: 'Agent information', status: 'current' },
  { label: 'Passengers', status: 'upcoming' },
  { label: 'Trip overview', status: 'upcoming' },
  { label: 'Travel preferences', status: 'upcoming' },
  { label: 'Review', status: 'upcoming' },
];